const integrationsDictEN = {
  // Integrations
  integrations: "Integrations",
  integrationsDescription:
    "Access integrated tools and applications ready for your activities on Extraconomy.",
  configure: "Configure",
  integrationData: "Integration data",

  // WhatsApp
  whatsappIntegrationDescription: "Manage the contact number visible in your store.",
  phoneNumber1: "Phone Number",
  enterYourPhoneNumber: "Enter your phone number",
  confirmationCode: "Confirmation Code",
  enterReceivedCode: "Enter the received code",
  goBackAndResendCode: "Go back and resend code",

  // Messages
  attention: "Attention",
  success: "Success",
  error: "Error",
  codeSent: "Code Sent",
  codeSentTo: "Code sent to",

  // Validations
  pleaseProvidePhoneNumber: "Please provide the phone number",
  pleaseProvideConfirmationCode: "Please provide the confirmation code",

  // Success
  confirmationCodeSentToWhatsApp: "Confirmation code sent to WhatsApp",
  whatsappConfiguredSuccessfully: "WhatsApp configured successfully!",
  configurationSavedSuccessfully: "Configuration saved successfully",

  // Errors
  errorConnectingToServer: "Error connecting to server",
  invalidConfirmationCode: "Invalid confirmation code",
  errorConfirmingCode: "Error confirming code",
};

export default integrationsDictEN;
